import { AvatarImg } from "web-ui";

import type { User } from "../api/v2";

export interface Props {
  className?: string;
  user: User;
}
const UserAvatar = ({ className, user }: Props) => (
  <AvatarImg
    className={className}
    user={{
      ...user,
      picture: `${user.picture}/medium`,
    }}
  />
);
export default UserAvatar;
